window.Branch.product.initPdpBundlePricing = function(){
    console.log('initPdpBundlePricing')
    const updateBundleDom = function(pdpBundle, currentPrice, originalPrice){
        const dealEl = pdpBundle.querySelector('.price span[data-price="deal"]');
        const retailEl = pdpBundle.querySelector('.price span[data-price="retail"]');
        if(dealEl){
            dealEl.innerHTML = `${Shopify.formatMoney(currentPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')}+`;
        }
        if(retailEl){
            retailEl.innerHTML = `${Shopify.formatMoney(originalPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')}`;
        }
        const percentageDiscount = Math.round(100 * ((originalPrice - currentPrice) / originalPrice));
        
        console.log('percentageDiscount', percentageDiscount)

        const percentageEl = pdpBundle.querySelector('.pdp-bundle__percentage-saving');
        if(percentageEl){
            percentageEl.innerHTML = percentageDiscount;
        }
        const saleEl = pdpBundle.querySelector('.pdp-bundle__body .sale');
        if(saleEl){
            saleEl.innerHTML = `save ${percentageDiscount}%`;
        }
    };

    const updateBundleDomGeneric = function(percentageDiscount, pdpBundle){        
        console.log('percentageDiscount', percentageDiscount)

        const percentageEl = pdpBundle.querySelector('.pdp-bundle__percentage-saving');
        if(percentageEl){
            percentageEl.innerHTML = percentageDiscount;
        }
        const saleEl = pdpBundle.querySelector('.pdp-bundle__body .sale');
        if(saleEl){
            saleEl.innerHTML = `save ${percentageDiscount}%`;
        }
    };

    const accumulateItem = function(price, comparePrice, handle, totals){
        const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(parseInt(price), parseInt(comparePrice), 0, '', handle);
        const adjustment = ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100 + 5;
        totals.originalPrice += codeDiscountData.originalPrice;
        totals.currentPrice += parseInt(price) * ((100 - adjustment) / 100);
    };

    document.querySelectorAll('.pdp-bundle').forEach((pdpBundle) => {
        const handle = pdpBundle.getAttribute('data-product-handle');
        if(!handle) {
            const mainProductHandle = window.meta && window.meta.product && window.meta.product.handle;
            const mainProductPercentageDiscount = 5 + window.Branch.functions.returnDiscountCodeUpdates(100, 100, 0, '', mainProductHandle).discountAmount;
            updateBundleDomGeneric(mainProductPercentageDiscount, pdpBundle);
        } else {
        const isPreset = pdpBundle.getAttribute('data-preset-bundle') === 'true';
        const dataSelector = isPreset
            ? `.preset_bundle_price_data[data-product-handle="${handle}"]`
            : `.per-variant-pricing[data-product-handle="${handle}"]`;
        const dataNode = document.querySelector(dataSelector);
        if(!dataNode) return;

        let priceData;
        try { priceData = JSON.parse(dataNode.innerText); } catch(e) { return; }

        const totals = { currentPrice: 0, originalPrice: 0 };

        if(isPreset){
            for(const productHandle in priceData){
                const { price, original_price } = priceData[productHandle];
                accumulateItem(price, original_price, productHandle, totals);
            }
            totals.originalPrice = Math.ceil(totals.originalPrice / 100) * 100;
            totals.currentPrice = Math.ceil(totals.currentPrice / 100) * 100;
        } else {
            const lowestPriceEntry = Object.values(priceData)[0];
            if(!lowestPriceEntry) return;
            if(lowestPriceEntry.constituents){
                lowestPriceEntry.constituents.forEach((constituent) => {
                    const qty = parseInt(constituent.quantity);
                    accumulateItem(parseInt(constituent.price) * qty, parseInt(constituent.compare_at_price) * qty, constituent.handle, totals);
                });
            } else {
                let originalPrice = lowestPriceEntry.opx === '' ? parseInt(lowestPriceEntry.cpx) : parseInt(lowestPriceEntry.opx);
                let currentPrice = parseInt(lowestPriceEntry.cpx);
                ({ currentPrice, originalPrice } = window.Branch.functions.returnDiscountCodeUpdates(currentPrice, originalPrice, 0, '', handle));
                totals.currentPrice = currentPrice;
                totals.originalPrice = originalPrice;
            }
        }
            updateBundleDom(pdpBundle, totals.currentPrice, totals.originalPrice);
        }
    });
};

window.Branch.product.initBundleBulkCollapse = function(){
    const container = document.querySelector('.main-product__bundles-bulk-discounts-container');
    if(!container) return;

    const bundle = container.querySelector('.pdp-bundle');
    const bulk = container.querySelector('.bulk-discounts-dropdown');

    const transitionMs = 200;

    const measureBundleNaturalHeight = function(){
        const prevHeight = bundle.style.height;
        const prevTransition = bundle.style.transition;
        bundle.style.transition = 'none';
        bundle.style.height = 'auto';
        const naturalHeight = bundle.getBoundingClientRect().height;
        bundle.style.height = prevHeight;
        void bundle.offsetHeight;
        bundle.style.transition = prevTransition;
        return naturalHeight;
    };

    const setBundleStatus = function(status){
        if(!bundle) return;
        const head = bundle.querySelector('.pdp-bundle__head');

        const currentHeight = bundle.getBoundingClientRect().height;
        bundle.style.height = currentHeight + 'px';

        bundle.setAttribute('data-status', status);
        if(head) head.setAttribute('aria-expanded', status === 'open' ? 'true' : 'false');

        void bundle.offsetHeight;

        const targetHeight = status === 'open'
            ? measureBundleNaturalHeight()
            : (head ? head.offsetHeight : currentHeight);
        bundle.style.height = targetHeight + 'px';

        if(status === 'open'){
            setTimeout(function(){
                if(bundle.getAttribute('data-status') === 'open'){
                    bundle.style.height = '';
                }
            }, transitionMs + 50);
        }
    };

    const closeBulkIfOpen = function(){
        if(!bulk) return;
        if(bulk.getAttribute('data-status') !== 'open') return;
        const cta = bulk.querySelector('.bulk-discounts-dropdown__cta');
        if(cta) cta.click();
    };

    if(bundle){
        const head = bundle.querySelector('.pdp-bundle__head');
        if(head){
            const toggle = function(){
                if(bundle.getAttribute('data-status') === 'open'){
                    setBundleStatus('closed');
                } else {
                    setBundleStatus('open');
                    closeBulkIfOpen();
                }
            };
            head.addEventListener('click', toggle);
            head.addEventListener('keydown', function(e){
                if(e.key === 'Enter' || e.key === ' '){
                    e.preventDefault();
                    toggle();
                }
            });
        }
    }

    let conditionsMetForObserver = !!bulk && !!bundle;

    if(conditionsMetForObserver){
        const observer = new MutationObserver(function(mutations){
            for(const m of mutations){
                if(m.attributeName === 'data-status' && bulk.getAttribute('data-status') === 'open'){
                    if(bundle.getAttribute('data-status') === 'open'){
                        setBundleStatus('closed');
                    }
                }
            }
        });
        observer.observe(bulk, { attributes: true, attributeFilter: ['data-status'] });
    }

    if(bundle && bundle.getAttribute('data-status') === 'closed'){
        const head = bundle.querySelector('.pdp-bundle__head');
        if(head){
            const prevTrans = bundle.style.transition;
            bundle.style.transition = 'none';
            bundle.style.height = head.offsetHeight + 'px';
            void bundle.offsetHeight;
            bundle.style.transition = prevTrans || '';
        }
    }

    if(container.getAttribute('data-bulk-discounts-open-by-default') === 'true' && bulk){
        requestAnimationFrame(function(){
            if(bulk.getAttribute('data-status') !== 'closed') return;
            const cta = bulk.querySelector('.bulk-discounts-dropdown__cta');
            if(cta) cta.click();
        });
    }
};


window.addEventListener("load", function() {
    window.Branch.product.initPdpBundlePricing();
    window.Branch.product.initBundleBulkCollapse();
});